import t from '@jetshop/intl';
import Accordion from '@jetshop/ui/Accordion/Accordion';
import BoolFilters from '@jetshop/ui/Filter/FilterTypes/BoolFilters';
import ListFilterAccordion from '@jetshop/ui/Filter/FilterTypes/List/ListFilterAccordion';
import RangeFilterAccordion from '@jetshop/ui/Filter/FilterTypes/Range/RangeFilterAccordion';
import SortOrderList from '@jetshop/ui/SortOrder/SortOrderList';
import theme from '@jetshop/ui/utils/theme';
import React from 'react';
import styled, { css } from 'react-emotion';
import { ReactComponent as Close } from '../../../svg/Close.svg';

const Title = styled('h1')`
  color: black;
  font-size: 1.125rem;
  text-align: center;
  padding: 1.5rem;
  font-weight: 600;
  font-family: ${theme('fontFamilies.heavy')};
  display: none;
`;

const Wrapper = styled('div')`
  padding-top: 110px;
  button {
    position: relative;
    padding: 0 1rem;
    border-width: 1px 0 0 0;
    & > svg {
      position: absolute;
      right: 16px;
      top: 20px;
    }
  }
  & > button {
    > svg {
      position: relative;
      right: 0;
      top: 0;
    }
  }
`;

const CloseButtonCSS = css`
  padding-left: 15px;
`;

const CloseButton = styled('button')`
  background: transparent;
  border: 0;
  outline: none;
  // margin-bottom: 30px;
  margin-bottom: 5px;
  padding: 0;
  padding-left: 15px;

  svg {
    height: 16px;
    width: 16px;
  }
`;

export default ({ filters, sortOrders, close, ...props }) => {
  const listFilters = (filters || []).filter(
    filter => filter.__typename === 'ListFilter'
  );

  const rangeFilters = (filters || []).filter(
    filter => filter.__typename === 'NumericRangeFilter'
  );

  const filterRef = React.useRef(null);

  React.useEffect(() => {
    const filterChildren =
      filterRef.current.children.length > 0 ? filterRef.current.children : null;
    if (filterChildren) {
      const childLength = filterChildren.length;
      for (let i = 0; i < childLength; i++) {
        const child = filterChildren[i];
        if (child.nodeName === 'DIV') {
          child.addEventListener('click', () => {
            close();
          });
        }
      }
    }
  }, [filterRef, close, filters]);

  return (
    <section {...props}>
      {filters ? (
        <Wrapper>
          <Title>{t('Filter')}</Title>
          <CloseButton onClick={close}>
            <Close />
          </CloseButton>
          <Accordion single>
            {accordionProps => (
              <React.Fragment>
                <div ref={filterRef}>
                  <ListFilterAccordion
                    listFilters={listFilters}
                    accordionProps={accordionProps}
                  />
                  <RangeFilterAccordion
                    rangeFilters={rangeFilters}
                    accordionProps={accordionProps}
                    startingIdx={listFilters.length}
                  />

                  <div css={{ padding: '1rem' }}>
                    <BoolFilters filters={filters} />
                  </div>
                </div>
              </React.Fragment>
            )}
          </Accordion>
        </Wrapper>
      ) : (
        <Wrapper>
          <Title>{t('Sort by')}</Title>
          <CloseButton css={CloseButtonCSS} onClick={close}>
            <Close />
          </CloseButton>
          <SortOrderList sortOrders={sortOrders} />
        </Wrapper>
      )}
    </section>
  );
};
